export default function desensitizationEmail(email) {
  if (email) {
    return (
      (email.split('@')[0].length <= 4 ? email.split('@')[0].substring(0, 1) : email.split('@')[0].substring(0, 4)) +
      '****@****' +
      (email.split('@')[1].length <= 4 ? email.split('@')[1].substring(email.split('@')[1].length - 1) : email.substring(email.length - 4))
      // email.substring(email.length - 4)
    );
  } else {
    return '';
  }
}
